import { styled } from '@mui/material';
import { QCard, QCardContent, QTypography } from '@kw/quokka-ui';

export const PolicyStatusCard = ({ title, value }: { title: string; value: number | string }) => {
  return (
    <StyledQCard>
      <QCardContent>
        <QTypography variant="h2Medium">{value}</QTypography>
        <QTypography variant="h5Medium" component="div">
          {title}
        </QTypography>
      </QCardContent>
    </StyledQCard>
  );
};

const StyledQCard = styled(QCard)({
  minWidth: 230,
  minHeight: 150,
  lineHeight: 5,
  textAlign: 'center',
  borderRadius: '8px',
  backgroundColor: 'rgba(255,255,255,0.6)',
  boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
});
